<p-toast></p-toast>
<div>
    <div class="card p-fluid p-formgrid justify-content-center dropdown-card" style="display: flex; flex-wrap:wrap">
        <!-- Userrid Dropdown -->
        <div class="field col-12 md:col-3">
            <label for="userrid">{{'User ID' | translate}}</label>
            <p-dropdown [options]="userRidList" appendTo="body" [(ngModel)]="selectedUserRid"
                placeholder="{{'Select User ID' | translate}}" optionLabel="UserID"></p-dropdown>
        </div>

        <!-- Apptype Dropdown -->
        <div class="field col-12 md:col-3">
            <label for="appType">{{'Application Type' | translate}}</label>
            <p-dropdown [options]="appTypeList" appendTo="body" [(ngModel)]="selectedAppType"
                placeholder="{{'Select App Type' | translate}}" optionLabel="status_Description"></p-dropdown>
        </div>

        <!-- Financial Year Dropdown -->
        <div class="field col-12 md:col-3">
            <label for="financialYear">{{'Financial Year' | translate}}</label>
            <p-dropdown [options]="financialYearList" appendTo="body" [(ngModel)]="selectedFinancialYear"
                placeholder="{{'Select Financial Year' | translate}}" optionLabel="FinancialYears"></p-dropdown>
        </div>

        <div class="field col-12 md:col-3">
            <button class="mt-4" pButton type="button" label="Get Data" (click)="fetchData()"></button>
        </div>
    </div>

</div>

<div *ngIf="showTable" class="card dashboardTable">
    <p-table #dt [value]="tableData" [rows]="10" [paginator]="true" responsiveLayout="scroll"
        [(selection)]="selectedApplications" [rowHover]="true" dataKey="id" style="margin-top: 15px;"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'Farmer Application(s)' | translate }}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH' | translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>App ID</th>
                <th>Farmer Name</th>
                <th>Programme Name</th>
                <th>Vendor Name</th>
                <th>Reg Date</th>
                <th>Village</th> 
                <th>District</th>
                <th>Block</th>
                <th>Status</th>
                <th>Fin Year</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td class="clickable-text" (click)="onClickApp(rowData.AppID)">{{rowData.AppID}}</td>
                <td>{{rowData.FarmerName}}</td>
                <td>{{rowData.ProgrammeName}}</td>
                <td>{{rowData.VendorName}}</td>
                <td>{{rowData.RegDate| date:'mediumDate'}}</td>
                <td>{{rowData.Village}}</td>
                <td>{{rowData.District}}</td>
                <td>{{rowData.Block}}</td>
                <td>{{rowData.Status}}</td>
                <td>{{rowData.FinYear}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>